import { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { BRAND, CONTACT } from "../data/content";

const NAV = [
  { to: "/", label: "Accueil" },
  { to: "/services", label: "Services" },
  { to: "/simulateur", label: "Simulateur" },
  { to: "/realisations", label: "Réalisations" },
  { to: "/blog", label: "Blog" },
  { to: "/a-propos", label: "À propos" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [location.pathname]);

  return (
    <header
      data-testid="header-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-black/70 backdrop-blur-xl border-b border-white/5" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-20">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-3">
          <img src={BRAND.logo} alt="Optimeo Habitat" className="h-11 w-11 rounded-lg object-cover" />
          <div className="hidden sm:block leading-tight">
            <div className="font-display uppercase text-white text-lg tracking-wide">Optimeo</div>
            <div className="text-[10px] uppercase tracking-[0.3em] text-[#7DD923]">Habitat</div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-sm font-medium tracking-wide transition-colors ${
                  isActive ? "text-[#7DD923]" : "text-white/80 hover:text-white"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            data-testid="header-call-btn"
            href={`tel:${CONTACT.phoneLink}`}
            className="btn-secondary !py-2 !px-4 text-xs"
          >
            <Phone className="w-4 h-4" /> {CONTACT.phoneDisplay}
          </a>
          <Link data-testid="header-cta-devis" to="/devis" className="btn-primary !py-2.5 !px-5 text-xs">
            Étude gratuite
          </Link>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-white/5" data-testid="mobile-menu">
          <nav className="flex flex-col p-6 gap-4">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-lg font-medium ${isActive ? "text-[#7DD923]" : "text-white"}`
                }
              >
                {n.label}
              </NavLink>
            ))}
            <Link to="/devis" data-testid="mobile-cta-devis" className="btn-primary mt-4 justify-center">
              Étude gratuite
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
